import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <div class="heading01 heading01b">
                <h2>{{ 'skill.Add new skill scale' | translate }}</h2>
                <ul class="actions01">
                    <li class="primary"><a class="btn main" ng-click="vm.addSkillScale()">{{ "skill.Add" | translate }}</a></li>
                    <li><a class="btn bordered02" ng-click="vm.uibModalInstance.dismiss()">{{ "skill.Cancel" | translate }}</a></li>
                </ul>
            </div>
            <div class="alert alert-danger" ng-if="vm.error">{{vm.error}}</div>
        </div>
        <div class="modal-body">
            <language-selector
                languages="vm.languages"
                selected="vm.selectedLang"
                data="vm.languageData"
                on-change="vm.onLangChange(lang, data)">
            </language-selector>
            <div class="form">
                <div class="row row-wide mt2em">
                    <div class="items">
                        <input type="text" placeholder="{{ 'skill.Enter name for the scale' | translate}}" class="form-control wide" ng-model="vm.languageData[vm.selectedLang].name">
                    </div>
                </div>
                <ul dnd-list="vm.languageData[vm.selectedLang].values" class="items06" ng-class="{'is-dragging': vm.down===true}">
                    <li ng-repeat="item in vm.languageData[vm.selectedLang].values"
                        dnd-draggable="item"
                        dnd-moved="vm.languageData[vm.selectedLang].values.splice($index, 1)"
                        dnd-effect-allowed="move"
                        dnd-selected="vm.values.selected = item"
                        ng-class="{'active': vm.values.selected === item, 'error': item.status === 'error', 'is-dragging': vm.down===true}"
                        dnd-dragend="vm.onDragEnd()"
                        dnd-dragstart="vm.down=true"
                    >
                        <dnd-nodrag>
                            <div dnd-handle class="handle"></div>
                            <p class="show-on-drag">{{item.value}}</p>
                            <div class="form hide-on-drag">
                                <div class="rowgroup inline">
                                    <div class="row row-wide">
                                        <label class="label w100p">{{ 'skill.points' | translate }}</label>
                                        <div class="items w100p">
                                            <input type="text" class="form-control small03" value="{{item.points}}" disabled>
                                        </div>
                                    </div>
                                    <div class="row row-wide primary">
                                        <label class="label w100p">{{ 'skill.Values' | translate }}</label>
                                        <div class="items w100p"><input type="text" class="form-control" ng-model="item.value" ng-change="vm.onValueChange(item, $index)"></div>
                                    </div>
                                    <a
                                        class="btn delete"
                                        ng-click="vm.deleteLevel(item, $index)">
                                    Remove
                                    </a>
                                </div>
                            </div>
                        </dnd-nodrag>
                    </li>
                </ul>
                <ul class="actions01 mt1em">
                    <li><a class="btn bordered02" ng-click="vm.addMoreLevels(1)">{{ 'skill.Add level' | translate }}</a></li>
                </ul>
            </div>
        </div>
    `
})

export default class {
    constructor (lodash, DATATABLES, SkillScaleResource, TokenService, toastr, $translate) {
        this.lodash = lodash;
        this.dt = DATATABLES;
        this.TokenService = TokenService;
        this.toastr = toastr;
        this.$translate = $translate;
        this.skillScaleResource = SkillScaleResource;
        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
    }
    $onInit () {
        this.tableOptions = this.lodash.merge({}, this.dt, {
            info: false,
            ordering: false,
            paging: false
        });
        this.defaultLanguage = this.TokenService.getCompanyLanguage() || this.TokenService.getActiveLanguage();
        // Keep a single selected reference for UI highlighting
        this.values = {
            selected: null
        };

        // Initialize languages for the selector (keep minimal structure)
        this.languages = this.getSortedLanguages();
        this.languageData = this.languageData || {};
        this.selectedLang = this.defaultLanguage;

        // Ensure each language bucket exists with name and values array
        this.languages.forEach(lang => {
            if (!lang || !lang.label) {
                return;
            }
            if (!this.languageData[lang.label]) this.languageData[lang.label] = {};

            if (typeof this.languageData[lang.label].enabled === 'undefined') {
                this.languageData[lang.label].enabled = !!lang.enabled;
            }

            if (!Array.isArray(this.languageData[lang.label].values)) this.languageData[lang.label].values = [];

            if (typeof this.languageData[lang.label].name === 'undefined') this.languageData[lang.label].name = '';
        });
        // Add an initial empty level for the selected language
        this.addMoreLevels(1, '');
    }

    getSortedLanguages () {
        const languages = [];
        this.lodash.forEach(this.companySupportedLanguages, lang => {
            if (lang === this.defaultLanguage) {
                languages.push({ label: lang, enabled: true });
            }
            else {
                languages.push({ label: lang, enabled: false });
            }
        });

        return languages;
    }

    /**
     * Handler for language selector changes, sync all the levels and points
     * @param language selected language code
     * @param data all the data for that language (enabled flag, name, points, values)
     */
    onLangChange (language, data) {
        this.selectedLang = language;
        // Sync parent languages array with the enabled flag from the data bucket
        if (language && this.languages && Array.isArray(this.languages)) {
            const entry = this.languages.find(
                lang => lang && lang.label === language
            );
            if (entry && data && typeof data.enabled !== 'undefined') {
                entry.enabled = !!data.enabled;
            }
        }
        // Persist the per-language data provided by the selector so it can be saved later
        if (!this.languageData) this.languageData = {};
        if (language) {
            this.languageData[language] = Object.assign({}, this.languageData[language], data);
        }
    }

    getActiveList () {
        const code = this.selectedLang;
        if (!this.languageData[code]) this.languageData[code] = { enabled: false, name: '', values: [] };
        if (!Array.isArray(this.languageData[code].values)) this.languageData[code].values = [];
        return this.languageData[code].values;
    }

    /**
     * Add more level dynamically to all languages
     * @param points
     * @param value
     */
    addMoreLevels (points, value = '') {
        // Ensure all language buckets and lists exist
        const codes = Array.isArray(this.languages) ? this.languages.map(l => l && l.label).filter(Boolean) : [];
        if (!this.languageData) this.languageData = {};

        codes.forEach(code => {
            if (!this.languageData[code]) this.languageData[code] = { enabled: false, name: '', values: [] };
            if (!Array.isArray(this.languageData[code].values)) this.languageData[code].values = [];
        });

        // Determine the current maximum length across languages
        const lengths = codes.map(code => this.languageData[code].values.length);
        const currentMax = lengths.length ? Math.max.apply(null, lengths) : 0;
        const targetLen = currentMax + 1;

        if (targetLen > 10) {
            this.error = this.$translate.instant('skill.Maximum of 10 levels are allowed');
            return;
        }
        // Backfill shorter languages up to currentMax
        codes.forEach(code => {
            const list = this.languageData[code].values;
            while (list.length < currentMax) {
                list.push({ proficiencyId: null, points: list.length + 1, value: '' });
            }
        });

        // Append the new level to every language; only active language may carry provided value
        const active = this.selectedLang || this.defaultLanguage;
        codes.forEach(code => {
            const list = this.languageData[code].values;
            list.push({ proficiencyId: null, points: targetLen, value: code === active ? value : '' });
        });
        // Reindex all languages to keep points sequential
        this.reindexPoints();
    }

    deleteLevel (item, index) {
        const activeList = this.getActiveList();
        let valueIndex = (typeof index === 'number') ? index : activeList.indexOf(item);
        if (valueIndex === -1 && this.values.selected) {
            valueIndex = activeList.indexOf(this.values.selected);
        }
        if (valueIndex > -1) {
            // getting language codes to delete null/undefined values
            const codes = Array.isArray(this.languages) ? this.languages.map(l => l && l.label).filter(Boolean) : [];

            codes.forEach(code => {
                const list = (this.languageData[code] && this.languageData[code].values) || [];
                if (valueIndex < list.length) {
                    list.splice(valueIndex, 1);
                }
            });
            this.values.selected = null;
            this.reindexPoints();
        }
    }

    onDragEnd () {
        this.down = false;
        this.synchronizeAllLanguagesOrder();
    }

    reindexPoints () {
        this.resetErrors();
        if (!this.languageData) return;
        Object.keys(this.languageData).forEach(code => {
            const list = this.languageData[code] && this.languageData[code].values;
            if (Array.isArray(list)) {
                list.forEach((row, i) => {
                    if (row) row.points = i + 1;
                });
            }
        });
    }

    onValueChange (item, index) {
        const list = this.getActiveList();
        if (!Array.isArray(list)) return;
        if (typeof index === 'number' && list[index]) {
            list[index].value = item ? item.value : '';
        }
    }

    beforeSave () {
        this.resetErrors();
        // Reindex all languages' lists to keep points sequential
        if (this.languageData) {
            Object.keys(this.languageData).forEach(code => {
                const bucket = this.languageData[code];
                if (bucket && Array.isArray(bucket.values)) {
                    bucket.values.forEach((row, i) => {
                        if (row) row.points = i + 1;
                    });
                }
            });
        }

        const baseLangEntry = (Array.isArray(this.languages) && (this.languages.find(l => l && l.label === this.defaultLanguage) || this.languages[0])) || null;
        const baseLang = (baseLangEntry && baseLangEntry.label) || this.selectedLang || this.defaultLanguage;
        const baseBucket = (this.languageData && this.languageData[baseLang]) || { name: '', values: [] };

        const list = Array.isArray(baseBucket.values) ? baseBucket.values : [];

        // Only contains valid, non-empty levels for base language.
        const cleanedPointsData = list
            .map((value, i) => (
                    { points: i + 1, value: (value && value.value) ? value.value : '' }
                )
            );

        if (cleanedPointsData.length < 2 || cleanedPointsData.length > 10) {
            this.error = this.$translate.instant('skill.Please add at least 2 or maximum 10 scales');
            return null;
        }

        const payload = {};
        const proficiency = {};
        if (this.languageData && Array.isArray(this.languages)) {
            this.languages.forEach(l => {
                const code = l && l.label;
                if (!code) return;

                payload[code] = {
                    is_enabled: this.languageData[code].enabled ? 1 : 0,
                    name: this.languageData[code].name
                };
                proficiency[code] = this.languageData[code].values;
            });
        }

        return {
            scaleI18ns: payload,
            proficiencies: proficiency
        };
    }
    addSkillScale () {
        const payload = this.beforeSave();
        if (!payload) return;
        this.saving = true;
        const promise = this.skillScaleResource.save(payload).$promise;
        promise.then((res) => {
            this.saving = false;
            this.uibModalInstance.close(res);
            this.toastr.success(this.$translate.instant('skill.Changes saved'));
        }).catch((err) => {
            this.saving = false;
            if (err.data.length) {
                this.error = err.data[0].message;
            }
        });
    }

    synchronizeAllLanguagesOrder () {
        this.resetErrors();
        if (!this.languageData || !this.selectedLang) return;

        const codes = Array.isArray(this.languages)
            ? this.languages.map(l => l && l.label).filter(Boolean)
            : [];

        // Use current language as the reference for order
        const referenceList = this.languageData[this.selectedLang].values;
        if (!Array.isArray(referenceList)) return;

        // Create a mapping of old points to new index
        const oldPointsToNewIndex = {};
        referenceList.forEach((item, newIndex) => {
            if (item && typeof item.points === 'number') {
                oldPointsToNewIndex[item.points] = newIndex;
            }
        });

        // Reorder other languages based on this mapping
        codes.forEach(code => {
            if (code === this.selectedLang) return;

            const list = this.languageData[code] && this.languageData[code].values;
            if (!Array.isArray(list)) return;

            const reordered = new Array(list.length);
            list.forEach(item => {
                if (item && typeof item.points === 'number') {
                    const newIndex = oldPointsToNewIndex[item.points];
                    if (typeof newIndex === 'number' && newIndex < reordered.length) {
                        reordered[newIndex] = item;
                    }
                }
            });

            this.languageData[code].values = reordered.filter(Boolean);
        });

        // Finally reindex all points
        this.reindexPoints();
    }

    resetErrors () {
        this.error = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/skills/scale/add/index.js